import React from "react"
import { Box, CircularProgress, Typography } from "@material-ui/core"
import useParametros from "../../contexts/ParametrosContext"
import useAppStore from "../../stores/AppStore"
import Cabecalho from "../Cabecalho"
import { ClubeBeneficiosContextProvider } from "./context/ClubeBeneficiosContextProvider"
import { ClubeBeneficios } from "./ClubeBeneficios"
import { clubeBeneficiosLiberado } from "./liberacao"

export function Index() {
    const parametros = useParametros()
    const perfil = useAppStore((s: any) => s.configuracoes?.user?.perfil)
    // Os parâmetros da loja chegam assíncronos ({} até carregar): não negar o acesso antes disso.
    const parametrosCarregados = !!parametros && Object.keys(parametros).length > 0

    if (clubeBeneficiosLiberado(perfil, parametros)) {
        return (
            <ClubeBeneficiosContextProvider>
                <ClubeBeneficios />
            </ClubeBeneficiosContextProvider>
        )
    }

    return (
        <>
            <Cabecalho pagina="Clube de Benefícios" />
            <Box style={{ paddingTop: 140, textAlign: "center" }}>
                {parametrosCarregados ? (
                    <Typography variant="body1" color="textSecondary">
                        O Clube de Benefícios ainda não está liberado para este estabelecimento.
                    </Typography>
                ) : (
                    <CircularProgress />
                )}
            </Box>
        </>
    )
}
